import { Component } from '@angular/core';

@Component({
  selector: 'app-platforms',
  imports: [],
  templateUrl: './platforms.html',
  styleUrl: './platforms.scss'
})
export class Platforms {

}
